import api from '@pray/shared/utils/api';

export type RetryWorkflowParams = {
  contentId: string;
  retriggerWorkflow?: boolean;
  retriggerEmail?: boolean;
  retriggerAnnouncement?: boolean;
};

export type RetryWorkflowResponse = {
  data: {
    id: string;
    triggered_workflow: boolean;
    triggered_email: boolean;
    triggered_announcement: boolean;
  };
};

export async function retryWorkflow({
  contentId,
  retriggerWorkflow,
  retriggerEmail,
  retriggerAnnouncement,
}: RetryWorkflowParams): Promise<RetryWorkflowResponse> {
  const url = `/web/studio/system-check/workflow/${contentId}/retry`;
  const response = await api.executePostRequest<RetryWorkflowResponse>(url, {
    retrigger_workflow: retriggerWorkflow,
    retrigger_email: retriggerEmail,
    retrigger_announcement: retriggerAnnouncement,
  });

  return response.data;
}
